import { useCallback, useState, MutableRefObject } from "react";

export const useRerender = (mountRef: MutableRefObject<boolean>) => {
  const setRerenderCount = useState(0)[1];

  return useCallback(() => {
    if (mountRef.current) setRerenderCount((rerenderCount) => ++rerenderCount);
  }, [setRerenderCount, mountRef]);
};
